import { render, staticRenderFns } from "./collect-button.vue?vue&type=template&id=4871f9a1&lang=pug&"
import script from "./collect-button.vue?vue&type=script&lang=js&"
export * from "./collect-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports